import React from 'react';
import { TextBox } from 'components/form/TextBox';
import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import { Notification } from 'components/Notification/Notification';
import { DropDown } from 'components/form/DropDown';
import { stateList } from 'helpers/address.helper';

const AddressErrorMessage = ({ errorMessage }) => {
  return (
    <Notification
      style={{}}
      type="error"
      id={1}
      duration={5000}
      transient={true}
      title={errorMessage}
      open={true}
      notClosable={true}
    />
  );
};

export const AddressForm = ({
  addressForm,
  hideBlockError,
  classNameOverwrites,
  isDisabledAptNumber,
  fullWidth,
  ...props
}) => {
  const getStateDisplay = () => {
    let states = [];
    for (const property in stateList) {
      states.push(stateList[property].name);
    }
    return states;
  };

  let states = getStateDisplay();

  const addressContainer =
    classNameOverwrites?.container ?? 'addressSection addressFormContainer';
  const stateZipContainer =
    classNameOverwrites?.stateZipContainer ??
    'flex-row noWrap tabletWrap justify-between stateZipCont';
  const separator =
    classNameOverwrites?.separator ?? 'mobileHide stateZipSeparator pad12';
  const streetContainer =
    classNameOverwrites?.streetContainer ?? 'inputContainer street';
  const cityContainer =
    classNameOverwrites?.cityContainer ?? 'inputContainer city';
  const cityStateZipRowContainer =
    classNameOverwrites?.cityStateZipRowContainer ?? 'flex-column';

  return (
    <div className={addressContainer}>
      {addressForm.addressErrorMessage && !hideBlockError && (
        <AddressErrorMessage errorMessage={addressForm.addressErrorMessage} />
      )}

      <FlexContainer className={streetContainer}>
        <TextBox
          id="current-street"
          name="street"
          datatestid="streetInput"
          type="text"
          autoComplete="new-password"
          aria-required="true"
          aria-invalid="false"
          className={'address-street '}
          value={addressForm.street}
          error={addressForm.streetError}
          placeholder="Street address"
          onChange={e => {
            e.persist();
            addressForm?.handleChange(e);
          }}
          fullWidth={fullWidth}
        />
      </FlexContainer>

      {!isDisabledAptNumber && (
        <div className="inputContainer unit">
          <TextBox
            id="current-unit"
            name="unit"
            type="text"
            datatestid="unitInput"
            placeholder="Apt, unit, etc. (optional)"
            value={addressForm?.unit}
            onChange={addressForm?.handleChange}
            autoComplete="new-password"
            fullWidth={fullWidth}
          ></TextBox>
        </div>
      )}

      <FlexContainer className={cityStateZipRowContainer}>
        <FlexContainer className={cityContainer}>
          <TextBox
            id="current-city"
            name="city"
            datatestid="cityInput"
            type="text"
            className={'address-city '}
            value={addressForm?.city}
            onChange={addressForm?.handleChange}
            error={addressForm?.cityError}
            placeholder="City"
            autoComplete="new-password"
            fullWidth={fullWidth}
          />
        </FlexContainer>

        <FlexContainer className={stateZipContainer}>
          <FlexContainer
            className="flex-column inputContainer state"
            style={{ width: '100%' }}
          >
            <DropDown
              id="current-state"
              datatestid="stateInput"
              onChange={value => addressForm?.handleUSStateChange(value)}
              placeholder="State"
              isEmptyState={!addressForm?.displayState}
              label="State"
              list={states}
              value={addressForm?.displayState}
              error={addressForm?.stateError}
              fullWidth={fullWidth}
            />
          </FlexContainer>
          <div className={separator}></div>

          <FlexContainer
            className="flex-column inputContainer zip"
            style={{ width: '100%' }}
          >
            <TextBox
              id="zip"
              name="zip"
              datatestid="zipInput"
              type="text"
              maxLength={5}
              inputMode="numeric"
              className={'address-zip '}
              onChange={addressForm?.handleChange}
              value={addressForm?.zip}
              error={addressForm?.zipError}
              placeholder="Zip code"
              autoComplete="new-password"
              fullWidth={fullWidth}
            />
          </FlexContainer>
        </FlexContainer>
      </FlexContainer>
    </div>
  );
};
